import { Theme } from "../component/navigation/ThemeDropdown";

export default function ZoomOutIcon({ theme }: { theme: Theme }) {
    return (
        <svg
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.25"
                width="13"
                height="1.5"
                rx="0.75"
                fill="black"
            />
            <rect
                x="0.5"
                y="0.25"
                width="13"
                height="1.5"
                rx="0.75"
                fill="black"
            />
            <rect
                x="0.5"
                y="0.25"
                width="13"
                height="1.5"
                rx="0.75"
                fill={theme === "light" ? "#535353" : "#7A8690"}
            />
        </svg>
    );
}
